import React from "react";

const DonorTotal = ({ currencySymbol, chuffedDonorAmountTotal, donorAmountTotal }) => (
  <div>
    <span className="fees__donation-form-fee fees__donation-form-fee-donor-amount">
      <p>Paid by donor:</p>
      <p className="fees__donation-form-amounts">
        {currencySymbol}
        {
            chuffedDonorAmountTotal > 0 || chuffedDonorAmountTotal != null
              ? chuffedDonorAmountTotal
              : donorAmountTotal
          }
      </p>
    </span>
  </div>
);

export default DonorTotal;
